import Calendar from 'antd/lib/calendar'

import 'antd/lib/calendar/style'

export * from 'antd/lib/calendar'

export default Calendar
